"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _dateInputModule = _interopRequireDefault(require("./date-input.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DATE_FORMAT = 'YYYY-MM-DD';
var DateInput = /*#__PURE__*/function (_Component) {
  function DateInput(props) {
    var _this;
    _classCallCheck(this, DateInput);
    _this = _callSuper(this, DateInput, [props]);
    _defineProperty(_this, "onBlur", function (event) {
      var inputClassName = _this.props.inputClassName;
      var combinedClassnames = (0, _classnames["default"])(_dateInputModule["default"].input, inputClassName);
      var nextTarget = event.relatedTarget;
      var dateInputFocused = nextTarget && nextTarget.className.indexOf(combinedClassnames) !== -1;
      if (!dateInputFocused) {
        var value = _this.computeFieldValue();
        _this.props.onBlur(value);
      }
    });
    var dateArray = _this.props.value ? _this.props.value.split(/-|\//g) : '';

    // month is 0 indexed
    var dateObject = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
    var formattedDate = dateObject ? (0, _dateFns.format)(dateObject, DATE_FORMAT) : null;
    _this.state = {
      day: formattedDate && (0, _dateFns.isValid)(dateObject) ? (0, _dateFns.format)(formattedDate, 'DD') : '',
      month: formattedDate && (0, _dateFns.isValid)(dateObject) ? (0, _dateFns.format)(formattedDate, 'MM') : '',
      year: formattedDate && (0, _dateFns.isValid)(dateObject) ? (0, _dateFns.format)(formattedDate, 'YYYY') : '',
      touched: false
    };
    return _this;
  }

  // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/225
  _inherits(DateInput, _Component);
  return _createClass(DateInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$state = this.state,
        day = _this$state.day,
        month = _this$state.month;
      if (nextProps.value !== '' && nextProps.value !== 'Invalid Date') {
        var date = nextProps.value;
        // Re-use string in state if number is the same
        // to prevent padding 0 as you type
        var sameDay = Number(day) === Number((0, _dateFns.format)(date, 'DD'));
        var sameMonth = Number(month) === Number((0, _dateFns.format)(date, 'MM'));
        this.setState({
          day: sameDay ? day : (0, _dateFns.format)(date, 'DD'),
          month: sameMonth ? month : (0, _dateFns.format)(date, 'MM'),
          year: (0, _dateFns.format)(date, 'YYYY')
        });
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(field, event) {
      var _this2 = this;
      if (event.target.validity && !event.target.validity.valid) {
        return;
      }
      var value = event.target.value;
      if (field === 'day') {
        var num = Number(value);
        if (value.length === 2 && (num === 0 || num > 31)) {
          return;
        }
      }
      if (field === 'month') {
        var _num = Number(value);
        if (value.length === 2 && (_num === 0 || _num > 12)) {
          return;
        }
      }
      this.setState(_defineProperty({}, field, value), function () {
        _this2.onChange();
      });
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var value = this.computeFieldValue();
      this.props.onChange(value);
    }
  }, {
    key: "computeFieldValue",
    value: function computeFieldValue() {
      var _this$state2 = this.state,
        day = _this$state2.day,
        month = _this$state2.month,
        year = _this$state2.year;
      if (day === '' || day === '0' || month === '' || month === '0' || year === '' || year.length !== 4) {
        return '';
      }

      // month is 0 indexed
      var date = new Date(year, month ? month - 1 : '', day);
      if ((0, _dateFns.isValid)(date)) {
        return (0, _dateFns.format)(date, DATE_FORMAT);
      }
      return 'Invalid Date';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        id = _this$props.id,
        inputClassName = _this$props.inputClassName,
        ariaDescribedBy = _this$props.ariaDescribedBy,
        onFocus = _this$props.onFocus;
      var _this$state3 = this.state,
        day = _this$state3.day,
        month = _this$state3.month,
        year = _this$state3.year;
      var inputStyles = (0, _classnames["default"])(_dateInputModule["default"].input, inputClassName);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _dateInputModule["default"].row,
        "data-jlds": true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _dateInputModule["default"].cell,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
            id: id,
            name: id,
            type: "tel",
            placeholder: "DD",
            maxLength: 2,
            onChange: function onChange(event) {
              return _this3.onInputChange('day', event);
            },
            onFocus: onFocus,
            onBlur: this.onBlur,
            value: day,
            className: inputStyles,
            "aria-describedby": ariaDescribedBy,
            extensionProps: {
              pattern: '\\d*'
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _dateInputModule["default"].cell,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
            id: "".concat(id, "-mm"),
            name: "".concat(id, "-mm"),
            type: "tel",
            placeholder: "MM",
            maxLength: 2,
            onChange: function onChange(event) {
              return _this3.onInputChange('month', event);
            },
            onFocus: onFocus,
            onBlur: this.onBlur,
            value: month,
            className: inputStyles,
            "aria-describedby": ariaDescribedBy,
            extensionProps: {
              pattern: '\\d*'
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _dateInputModule["default"].cell,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
            id: "".concat(id, "-yyyy"),
            name: "".concat(id, "-yyyy"),
            placeholder: "YYYY",
            type: "tel",
            maxLength: 4,
            onChange: function onChange(event) {
              return _this3.onInputChange('year', event);
            },
            onFocus: onFocus,
            onBlur: this.onBlur,
            value: year,
            className: inputStyles,
            "aria-describedby": ariaDescribedBy,
            extensionProps: {
              pattern: '\\d*'
            }
          })
        })]
      });
    }
  }]);
}(_react.Component);
_defineProperty(DateInput, "propTypes", {
  id: _propTypes["default"].string,
  inputClassName: _propTypes["default"].string,
  ariaDescribedBy: _propTypes["default"].string
});
_defineProperty(DateInput, "defaultProps", {
  id: '',
  inputClassName: '',
  ariaDescribedBy: ''
});
var _default = exports["default"] = DateInput;